module.exports = __webpack_public_path__ + "media/workplace/rating-good-4a69eb0b.svg";